import { DocumentType } from '../operations/createDocument/DocumentType';
import { ControlFacet } from '../models/controls/ControlFacet';

export const createDocumentActionControl = new ControlFacet<{
  itemKey: string;
  documentType: DocumentType;
}, {
    isAvailable: boolean;
    askForFileName: boolean;
    validator: (fileName: string) => string | undefined;
    openWindow: (props: { url?: string; }) => Window | null;
  }>('createDocumentAction');
